import {IEnvironment} from '../app/application/environment.provider'

export const environment: IEnvironment = {
  production: false,
  authServiceUrl: 'https://spb-common-api-stage.internal.sparbankensyd.se/service',
  dataServiceUrl: 'https://api-loan-renewal-test.internal.sparbankensyd.se/api',
  //profitUrl: 'https://localhost.sparbanken.me:4400/',
  profitUrl: 'https://lk-test.internal.sparbankensyd.se',
  villkorHost: 'villkor-test.lana.sparbankensyd.se',
  // Stage bc we are running on production bankid
  domain: 'ov-stage.internal.sparbankensyd.se',
  testMode: true
}
